<template>
    <group-backend-layout :page-title="'Admin Profile - ' + admin.full_name">
        <template #page_header>
            <div class="mb-8 flex justify-between border-b pb-4">
                <div class="flex flex-col gap-4">
                    <h1 class="text-[28px] font-semibold">
                        {{ admin.full_name }}
                    </h1>
                </div>
                <div
                    class="hidden items-center gap-4 lg:flex"
                    v-if="form.isDirty"
                >
                    <div class="btn btn-outline" @click="reset">
                        Discard Changes
                    </div>
                    <div class="btn btn-primary" @click="save">
                        Save Changes
                    </div>
                </div>
            </div>
        </template>

        <div class="flex gap-8">
            <div class="flex flex-col gap-4 md:flex-row">
                <div class="">
                    <div
                        v-if="admin.avatar"
                        class="group relative h-[160px] w-[160px] rounded border border-gray-400 bg-gray-250 bg-cover bg-center bg-no-repeat"
                        :style="'background-image: url(' + admin.avatar + ')'"
                    >
                        <div
                            class="invisible absolute bottom-0 flex w-full group-hover:visible"
                        >
                            <span
                                class="flex-grow rounded-b bg-black/75 px-2 py-1 text-center text-[14px] font-medium text-white hover:cursor-pointer hover:bg-white hover:text-black"
                                @click="editAvatar()"
                                title="Edit / Remove"
                            >
                                Edit / Remove
                            </span>
                        </div>
                    </div>

                    <drag-image-upload-field
                        v-else
                        v-model="form.avatar"
                        image-preview-css="h-[160px] w-[160px] border border-gray-400 bg-gray-250"
                    >
                        <div class="text-center">
                            <div class="">Upload an admin&nbsp;avatar</div>
                            <div class="text-[12px] font-medium">
                                (jpg or png)
                            </div>
                        </div>
                    </drag-image-upload-field>
                </div>
                <div class="flex flex-col gap-4">
                    <div class="flex flex-row gap-2">
                        <form-input
                            label="First name"
                            name="first_name"
                            v-model="form.first_name"
                        />
                        <form-input
                            label="Last name"
                            name="last_name"
                            v-model="form.last_name"
                        />
                    </div>
                    <div class="flex flex-row gap-2">
                        <form-input
                            label="Email"
                            name="email"
                            type="email"
                            v-model="form.email"
                        />
                    </div>
                    <div class="relative flex flex-row gap-2">
                        <form-input
                            label="Password"
                            name="password"
                            type="password"
                            model-value="dummy-password"
                            :disabled="true"
                        />
                        <Link
                            v-if="admin.id !== $page.props.auth.user.id"
                            :href="
                                route('user.send-password-reset', {
                                    user_id: admin.id,
                                })
                            "
                            class="link absolute right-0 top-0 text-[14px]"
                            >Send password reset link
                        </Link>
                        <new-modal ref="changePasswordModal" v-else>
                            <template #trigger>
                                <span
                                    class="link absolute right-0 top-0 text-[14px]"
                                    >Change Password</span
                                >
                            </template>
                            <template #content>
                                <user-change-password
                                    v-on:password-changed="
                                        closePasswordChangeModal
                                    "
                                ></user-change-password>
                            </template>
                        </new-modal>
                    </div>
                    <div class="">
                        <label
                            for=""
                            class="mb-2 block block text-[14px] text-base font-medium font-semibold"
                            ><span>Role</span></label
                        >
                        <GroupAdminPermissionSelectAndChange :admin="admin" />
                    </div>
                </div>
            </div>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import FormInput from "@/Components/FormInput";
import DragImageUploadField from "@/Components/DragImageUploadField";
import FormSelect from "@/Components/FormSelect";
import NewModal from "@/Components/NewModal";
import GroupAdminPermissionSelectAndChange from "@/Components/GroupAdminPermissionSelectAndChange";
import UserChangePassword from "@/Components/UserChangePassword";

export default {
    name: "GroupAdminShow",
    components: {
        UserChangePassword,
        NewModal,
        FormSelect,
        GroupBackendLayout,
        FormInput,
        DragImageUploadField,
        GroupAdminPermissionSelectAndChange,
    },
    props: {
        admin: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                avatar: this.admin.avatar,
                first_name: this.admin.first_name,
                last_name: this.admin.last_name,
                email: this.admin.email,
                permissionLevelId: this.admin.group_admin_permission_level,
            }),
        };
    },
    methods: {
        editAvatar() {
            this.admin.avatar = null;
            this.form.avatar = null;
        },
        save() {
            this.form.post(
                route("group.admin.update", { user: this.admin.id })
            );
        },
        reset() {
            this.$inertia.visit(
                route(route().current(), { user: this.admin.id })
            );
        },
        closePasswordChangeModal() {
            this.$refs.changePasswordModal.closeModal();
        },
    },
};
</script>
